<template>
  <div :class="`nr-task-card ${tagColor}-border-color`">
    <div class="nr-task-card-content-header">
      <NrTooltip :label="identifier">
        <div class="task-user-name">
          {{ truncate(identifier, { length: '82' }) }}
        </div>
      </NrTooltip>
      <div class="task-tag-actions-container">
        <div class="task-tag-actions-row">
          <NrTag class="task-tag" :tagColor="tagColor" :label="label" />
          <div class="task-actions" v-if="hasActionPermission && withIcons">
            <NrTooltip :label="taskLabel" :parent-target="false">
              <NrIconButton
                variant="minimal-neutral"
                :icon="{
                  name: taskComplete ? 'ban' : 'check-circle',
                  type: 'regular'
                }"
                size="small"
                @click="$emit('handle-complete', id)"
                :aria-label="taskLabel"
              />
            </NrTooltip>
            <NrTooltip label="Edit task">
              <NrIconButton
                variant="minimal-neutral"
                size="small"
                :icon="{ name: 'pencil-alt', type: 'regular' }"
                @click="$emit('handle-edit', id)"
                aria-label="Edit task"
              />
            </NrTooltip>
            <NrTooltip label="Delete task">
              <NrIconButton
                variant="minimal-neutral"
                size="small"
                :icon="{ name: 'trash-alt', type: 'regular' }"
                @click="$emit('handle-delete', id)"
                aria-label="Delete task"
              />
            </NrTooltip>
          </div>
        </div>
      </div>
    </div>
    <div class="content">
      <slot />
    </div>
  </div>
</template>

<script>
import NrIconButton from '@nextrequestco/components/src/components/NrIconButton'
import NrTooltip from '@nextrequestco/components/src/components/NrTooltip'
import NrTag from '@nextrequestco/components/src/components/NrTag'
import truncate from 'lodash/truncate'
export default {
  name: 'NrTaskCard',
  props: {
    id: {
      type: [String, Number],
      default: null
    },
    identifier: {
      type: String,
      default: ''
    },
    status: {
      type: String,
      required: true,
      validator(value) {
        return ['Complete', 'Incomplete', 'Due soon', 'Overdue'].includes(value)
      }
    },
    date: {
      type: String,
      required: true
    },
    hasActionPermission: {
      type: Boolean,
      default: false
    },
    withIcons: {
      type: Boolean,
      default: true
    }
  },
  components: { NrIconButton, NrTooltip, NrTag },
  computed: {
    taskComplete() {
      return this.status === 'Complete'
    },
    taskLabel() {
      return !this.taskComplete ? 'Mark task complete' : 'Mark task incomplete'
    },
    tagColor() {
      const color = {
        Complete: 'green',
        Incomplete: 'gray',
        'Due soon': 'yellow',
        Overdue: 'red'
      }
      return color[this.status]
    },
    label() {
      return `${this.status}: ${this.date}`
    }
  },
  methods: {
    truncate
  }
}
</script>

<style lang="scss">
@import '@nextrequestco/components/src/styles/tokens/tokens.scss';

.nr-task-card {
  background: $color-white;
  padding: $spacing-8;
  &-content {
    &-header {
      display: flex;
      @media (max-width: 500px) {
        display: unset;
      }
      .task-user-name {
        font-weight: $font-weight-semibold;
      }
      .task-tag-actions-container {
        margin-left: auto;
      }
      .task-tag-actions-row {
        display: flex;
        justify-content: space-between;

        @media (max-width: 1400px) {
          .task-tag {
            display: inline-table;
            text-align: center;
          }
        }
      }
      .task-actions {
        margin-left: $spacing-8;
      }
    }
  }
  &:hover {
    box-shadow: $shadow-4;
    position: relative;
    z-index: 1;
  }
}

.nr-task-card {
  border: solid $border-width-default $color-gray-20;
  &.gray-border-color {
    &:hover {
      border: solid $border-width-default $color-gray-40;
    }
  }
  &.green-border-color {
    &:hover {
      border: solid $border-width-default $color-green-100;
    }
  }
  &.yellow-border-color {
    &:hover {
      border: solid $border-width-default $color-yellow-100;
    }
  }
  &.red-border-color {
    &:hover {
      border: solid $border-width-default $color-red-100;
    }
  }
}
</style>
